module.exports = __webpack_public_path__ + "assets/images/pages/unleash/icon-unleash-1.png?c2ada072";